import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { TargetType } from '../entities/target-type';

export class TargetTypeRequest extends BaseRequest {
    targetType : TargetType;

    constructor(userInfo : UserInfo){
        super(userInfo);
        this.targetType = new TargetType()
      }
}


